<template>
    <footer>
        <ul class="nav justify-content-center" v-if="!isMobile">
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="/faq/vermieter">FAQ für Vermieter</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="/agb">AGB</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="/impressum">Impressum</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" target="_blank" href="/policy">Datenschutz</a>
            </li>
        </ul>
        <div class="container" v-else>
            <div class="row">
                <div class="col-6 text-center border-footer">
                    <a class="nav-link" target="_blank" href="/faq/vermieter">FAQ für Vermieter</a>
                </div>
                <div class="col-6 text-center border-footer">
                    <a class="nav-link" target="_blank" href="/agb">AGB</a>
                </div>
            </div>
            <div class="row">
                <div class="col-6 text-center border-footer">
                    <a class="nav-link" target="_blank" href="/impressum">Impressum</a>
                </div>
                <div class="col-6 text-center border-footer">
                    <a class="nav-link" target="_blank" href="/policy">Datenschutz</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { IsMobileMixin } from '../../mixins/IsMobile';
    export default {
        mixins: [IsMobileMixin]
    }
</script>

<style scoped>
.border-footer{
    border: 2px solid #c6ffc6;
}
</style>